<template>
  <div>
    <FieldTitle :model="model" />
    <div v-if="readOnly" class="pb-10">
      <div class="pr-0 cursor-default w-full text-lg">
        <TableView :table="table" :readOnly="readOnly" :pageId="pageId" />
      </div>
    </div>
    <div v-else class="flex text-lg pb-10">
      <div class="w-full pr-0">
        <TableView :table="table" :readOnly="readOnly" :pageId="pageId" />
      </div>
      <div class="hidden pr-0 mb-4 xl:block lg:pl-4">
        <CommentPane v-if="!model.deactivateComments" :model="model.comments" :contentGuid="model.contentGuid"
          :pageId="pageId" :fieldTitle="model.title" @pinned-change="onCommentPanePinnedChange" />
      </div>
    </div>
  </div>
</template>

<script>
import CommentPane from '@/views/components/schema/CommentPane.vue';
import FieldTitle from '@/views/components/schema/common/FieldTitle.vue';
import TableView from '@/views/components/schema/table/TableView.vue';

export default {
  props: {
    model: {
      type: Object,
      required: true,
    },
    pageId: {
      type: String,
      required: false,
    },
    readOnly: {
      type: Boolean,
      required: false,
    },
    preview: {
      type: Boolean,
      required: false,
    },
  },
  data() {
    return {
      table: this.model.properties.table == null ? [] : this.model.properties.table,
    };
  },
  emits: ['comment-pane-pinned-change'],
  methods: {
    onCommentPanePinnedChange(payload) {
      this.$emit('comment-pane-pinned-change', payload);
    },
  },
  components: {
    CommentPane,
    FieldTitle,
    TableView,
  },
};
</script>
